const layoutVariations = {
  none: '',
  floatRight: 'float-right',
  floatLeft: 'float-left',
  twoColumns: 'two-columns',
};

export default layoutVariations;
